module.exports = __webpack_public_path__ + "static/media/facial-capture-loading-blue.1e1b04cf.svg";